import { HubConnection, HubConnectionBuilder, HubConnectionState, LogLevel } from '@microsoft/signalr';
import { serviceURLs, platformAdminService } from './axios.constant';

export interface WolverineEnvelope<T = unknown> {
  type: string;
  data: T;
}

export type NotificationListener = (envelope: WolverineEnvelope) => void;

let connection: HubConnection | null = null;
const listeners = new Set<NotificationListener>();

function hubUrl(): string {
  const baseUrl = window.gbl_service_urls[serviceURLs[platformAdminService]] as string;
  return `${baseUrl.replace(/\/$/, '')}/hubs/notifications`;
}

function ensureConnection(): HubConnection {
  if (connection) return connection;

  connection = new HubConnectionBuilder()
    .withUrl(hubUrl())
    .withAutomaticReconnect()
    .configureLogging(LogLevel.Warning)
    .build();

  connection.on('ReceiveMessage', (json: string) => {
    const envelope = JSON.parse(json) as WolverineEnvelope;
    listeners.forEach(l => l(envelope));
  });

  return connection;
}

export async function subscribeToNotifications(listener: NotificationListener): Promise<() => void> {
  listeners.add(listener);

  const conn = ensureConnection();
  if (conn.state === HubConnectionState.Disconnected) {
    await conn.start();
  }

  return () => {
    listeners.delete(listener);
  };
}
